module.exports = __webpack_public_path__ + "static/media/bg-achievement.af508873.gif";


//////////////////
// WEBPACK FOOTER
// ./src/modules/wechatShare/components/images/bg-achievement.gif
// module id = 883
// module chunks = 0